var map = {
	"./AppBarCart": 8463,
	"./AppBarCart.js": 8463,
	"./CardButtonVertical": 285,
	"./CardButtonVertical.js": 285,
	"./CardButtonWithCounter": 6963,
	"./CardButtonWithCounter.js": 6963,
	"./CardInput": 415,
	"./CardInput.js": 415,
	"./CartItem": 8672,
	"./CartItem.js": 8672,
	"./CashierProductPage": 2246,
	"./CashierProductPage.js": 2246,
	"./ComponentToPrint": 8896,
	"./ComponentToPrint.js": 8896,
	"./ConfettiAnimation": 5571,
	"./ConfettiAnimation.js": 5571,
	"./Create": 1085,
	"./Create.js": 1085,
	"./CreateMap": 1190,
	"./CreateMap.js": 1190,
	"./CustomizationSection": 137,
	"./CustomizationSection.js": 137,
	"./DiscountSection": 4063,
	"./DiscountSection.js": 4063,
	"./ExtraSection": 160,
	"./ExtraSection.js": 160,
	"./Footer": 834,
	"./Footer.js": 834,
	"./FooterMap": 6774,
	"./FooterMap.js": 6774,
	"./Footer_Store": 3768,
	"./Footer_Store.js": 3768,
	"./IconButtonsGroup": 2192,
	"./IconButtonsGroup.js": 2192,
	"./ImageSlides": 1193,
	"./ImageSlides.js": 1193,
	"./Invoice": 7910,
	"./Invoice.js": 7910,
	"./InvoicePrinter": 9468,
	"./InvoicePrinter.js": 9468,
	"./LabelToPrint": 2975,
	"./LabelToPrint.js": 2975,
	"./LabelToPrintHolder": 2649,
	"./LabelToPrintHolder.js": 2649,
	"./LanguagePage": 4396,
	"./LanguagePage.js": 4396,
	"./Loading": 1373,
	"./Loading.js": 1373,
	"./LottieAnimationWithLocalFile": 2161,
	"./LottieAnimationWithLocalFile.js": 2161,
	"./LottieAnimationWithUrl": 7329,
	"./LottieAnimationWithUrl.js": 7329,
	"./Map": 1951,
	"./Map.js": 1951,
	"./MapLanding": 8656,
	"./MapLanding.js": 8656,
	"./MapMarkerDetailWindow": 2208,
	"./MapMarkerDetailWindow.js": 2208,
	"./MasonryImageList": 5751,
	"./MasonryImageList.js": 5751,
	"./MoreInfo": 9192,
	"./MoreInfo.js": 9192,
	"./Navbar": 4856,
	"./Navbar.js": 4856,
	"./Navigation": 3283,
	"./Navigation.js": 3283,
	"./NoteSection": 8982,
	"./NoteSection.js": 8982,
	"./NumberDial": 6546,
	"./NumberDial.js": 6546,
	"./PDFToPrint": 1271,
	"./PDFToPrint.js": 1271,
	"./Page": 9838,
	"./Page.js": 9838,
	"./PageNotFound": 9305,
	"./PageNotFound.js": 9305,
	"./PayPal": 9859,
	"./PayPal.js": 9859,
	"./PaymentAnimation": 7677,
	"./PaymentAnimation.js": 7677,
	"./PaypalAnimation": 2222,
	"./PaypalAnimation.js": 2222,
	"./ProductDial": 2664,
	"./ProductDial.js": 2664,
	"./ProductItem": 9702,
	"./ProductItem.js": 9702,
	"./ProductPage": 7841,
	"./ProductPage.js": 7841,
	"./ProductSectionAccordion": 5753,
	"./ProductSectionAccordion.js": 5753,
	"./PugDogAnimation": 1389,
	"./PugDogAnimation.js": 1389,
	"./QztrayCashierPrinter": 801,
	"./QztrayCashierPrinter.js": 801,
	"./QztrayPrinter": 7204,
	"./QztrayPrinter.js": 7204,
	"./ScrollButtons": 8987,
	"./ScrollButtons.js": 8987,
	"./ScrollTop": 9457,
	"./ScrollTop.js": 9457,
	"./SimpleButtonsGroup": 5151,
	"./SimpleButtonsGroup.js": 5151,
	"./SimpleCardButton": 1669,
	"./SimpleCardButton.js": 1669,
	"./SimpleCardButtonGroup": 8998,
	"./SimpleCardButtonGroup.js": 8998,
	"./Size": 3452,
	"./Size.js": 3452,
	"./StoreInfo": 7246,
	"./StoreInfo.js": 7246,
	"./StoreInfoAccordion": 715,
	"./StoreInfoAccordion.js": 715,
	"./StoreMain": 2541,
	"./StoreMain.js": 2541,
	"./Stripe": 1788,
	"./Stripe.js": 1788,
	"./StripeCard": 2842,
	"./StripeCard.js": 2842,
	"./StripeRedirect": 8476,
	"./StripeRedirect.js": 8476,
	"./TextOnlyInvoice": 8073,
	"./TextOnlyInvoice.js": 8073,
	"./TicketPrinter": 4633,
	"./TicketPrinter.js": 4633,
	"./WindowScrollButtons": 8119,
	"./WindowScrollButtons.js": 8119,
	"./ZReport": 1745,
	"./ZReport.js": 1745,
	"./device": 1079,
	"./device.js": 1079,
	"./logo.png": 4096,
	"./pageSections/CtaAndLargeImageWithTitleAndText": 5886,
	"./pageSections/CtaAndLargeImageWithTitleAndText.js": 5886,
	"./pageSections/OrganizationIntroduction": 6601,
	"./pageSections/OrganizationIntroduction.js": 6601,
	"./pageSections/SimpleFeatures": 8008,
	"./pageSections/SimpleFeatures.js": 8008,
	"./pageSections/SimpleFooter": 3996,
	"./pageSections/SimpleFooter.js": 3996,
	"./pageSections/SimpleTitleAndButton": 5824,
	"./pageSections/SimpleTitleAndButton.js": 5824,
	"./pageSections/Template": 1039,
	"./pageSections/Template.js": 1039,
	"./pageSections/TestimonialWithAvatarButtons": 9206,
	"./pageSections/TestimonialWithAvatarButtons.js": 9206,
	"./pageSections/ThreeCardsWithEachCardAlongWithDescriptionAndBtn": 2451,
	"./pageSections/ThreeCardsWithEachCardAlongWithDescriptionAndBtn.js": 2451,
	"./pageSections/ThreeSimpleCardsAndTexts": 4551,
	"./pageSections/ThreeSimpleCardsAndTexts.js": 4551,
	"./parts/Section": 6711,
	"./parts/Section.js": 6711,
	"./parts/Sections": 7762,
	"./parts/Sections.js": 7762,
	"./parts/SiteNavigation": 5343,
	"./parts/SiteNavigation.js": 5343,
	"./theme_dark": 9043,
	"./theme_dark.js": 9043,
	"./theme_except_palette": 7174,
	"./theme_except_palette.js": 7174,
	"./theme_light": 9187,
	"./theme_light.js": 9187,
	"./useFetch": 1812,
	"./useFetch.js": 1812
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8720;